import React from 'react';
import {Switch} from 'react-router-dom';

import AppLayout from 'containers/ui/layout/AppLayout';

import NoMatch from 'routes/NoMatch';
import PrivateRoute from 'routes/PrivateRoute';
import SpogRoute from 'routes/SpogRoute';


export default {
    createRoute(route, _routes, state) {
        const auth = state ? state.auth : route.state.auth;
        let authorized;

        if (route.requiredServices) {
            if (auth.user && auth.user.services) {
                authorized = route.requiredServices.every(e => auth.user.services.includes(e));
            } else {
                authorized = false;
            }
        } else {
            authorized = true;
        }

        if (route.redirect) {
            const redirect = _routes.find(({path}) => path === route.redirect) || {};

            if (redirect) {
                return this.createRoute({
                    ...redirect,
                    path: route.path,
                    state
                });
            }
        }

        if (route.private) {
            if (route.onlyInternals) {
                if (auth.user && auth.user.canImpersonate) {
                    return (
                        <PrivateRoute
                            key={route.path}
                            exact
                            path={route.path}
                            authorized={authorized}
                            extra={route.extra}
                            component={route.component}
                        />);
                }

                return null;
            }

            return (
                <PrivateRoute
                    key={route.path}
                    exact
                    path={route.path}
                    authorized={authorized}
                    extra={route.extra}
                    component={route.component}
                />);
        }

        return (
            <SpogRoute
                key={route.path}
                exact
                path={route.path}
                component={route.component}
            />);
    },
    createRoutes(routes, isExternal, state) {
        return routes.filter(route => {
            if (isExternal) {
                return route.isExternal;
            }

            return !route.isExternal;
        }).map(route => this.createRoute(route, routes, state));
    },
    createSwitch(routes, state) {

        return (
            <AppLayout>
                <Switch>
                    {this.createRoutes(routes, true, state)}
                    {this.createRoutes(routes, false, state)}
                    <SpogRoute key="no-match" component={NoMatch} />
                </Switch>
            </AppLayout>
        );
    }
};



// WEBPACK FOOTER //
// ./src/util/routeUtils.js